import { Link } from "react-router-dom"

const PageNoFound = () => {
  return (
    <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
        <h1>404</h1>
      <h2>A página que você está visualizando não existe.</h2>
        <Link className="btn" to="/home/">Voltar Pra Home</Link>
        <img src="/assets/img/not-found.svg" className="img-fluid py-5" alt="Page Not Found" />
        <div className="credits">
          Criado por <a href="#">Sat Sistemas</a>
        </div>
      </section>
  )
}

export default PageNoFound